import PropTypes from "prop-types";
import React from 'react';
import { Button } from "reactstrap";

/**
 * RefreshButton - DataGrid'deki veri tablolarını yenilemek için kullanılan buton komponenti
 * 
 *   
 *
 * 
 *
 * @param {Object} props
 * @param {Function} props.onClick - Sayfayı yenilemede kullanılan fonksiyon bura eklenir 
 * @param {boolean} [props.disabled=false] - Butonun devre dışı olup olmadığını belirten prop
 * 
 * 
 * 
 */


const RefreshButton = ({ onClick, disabled = false }) => {
    return (
        <Button
            color="light"
            outline
            disabled={disabled}
            style={{ paddingInline: "10px", border: "1px solid #ddd" }}
            onClick={onClick}
        >
            <i className="fa fa-refresh" />
        </Button>
    );
};

RefreshButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

export default RefreshButton;